/* eslint-disable eqeqeq */
/* eslint-disable no-console */
import React from "react";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import TrikeIcon from "../../../Common/Svgs/TrikeIcon";
import SpeedLimit from "../../Trips/TripDetails/SpeedLimit";
import LabelAndValue from "./LabelAndValue";
import { updateRental } from "../../../Redux/Slices/rentals.slice";
import ReceivedBy from "./ReceivedBy";
import capitalize from "../../../Utils/capitalize";
import useRule from "../../../Core/hooks/useRule";
import { TENANT_RULE_VALUE } from "../../Login/constants";
import VehicleChanged from "./VehicleChanged";

const VehicleInformation = ({ details }) => {
  const dispatch = useDispatch();

  const hasChecklistAccess = useRule([TENANT_RULE_VALUE.CHECKLIST]);

  // check if the vehicle was changed
  const hasChangedVehicle = !!details?.metaData?.trikeChangeReason?.length;

  const total = details?.checklist?.length || 0;
  const passed = details?.checklist?.filter((c) => c?.passed == 1)?.length || 0;

  const getDriverName = () => {
    if (!details?.firstName) return "--";

    return `${capitalize(details?.firstName || "")} ${capitalize(
      details?.lastName || "",
    )}`;
  };

  return (
    <div className="bg-background-white p-4 h-[202px] border-[0.5px] border-light-grey rounded-md">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-x-2">
          <div className="flex items-center gap-x-2.5">
            <div className="w-[38px] h-[38px] flex items-center justify-center rounded-full bg-primary">
              <TrikeIcon size={16} className="text-background-white" />
            </div>

            <p className="font-poppins font-medium text-base">
              Vehicle Information
            </p>
          </div>

          {hasChangedVehicle && <VehicleChanged details={details} />}
        </div>

        <SpeedLimit title="Max. Speed 20 Km/Hr" />
      </div>

      <div className="ml-12 mt-6 flex items-center gap-x-[95px]">
        <LabelAndValue label="Driver name" value={getDriverName()} />

        <LabelAndValue
          label="Vehicle no."
          value={details?.trikeRegistrationNo || ""}
        />

        <LabelAndValue
          label="Date of trip"
          value={dayjs(details?.submittedAt).format("MMM DD, YYYY, hh:mm a")}
        />
      </div>

      <div className="ml-12 mt-6 flex items-center gap-x-[95px]">
        <LabelAndValue label="Odometer start-end" value="--" />

        {hasChecklistAccess && (
          <LabelAndValue
            label="Safety checklist"
            value={`${passed}/${total}`}
            onClick={() =>
              dispatch(
                updateRental({
                  key: "checklistModal",
                  value: {
                    visible: true,
                    data: {
                      trikeId: details?.trikeId || 0,
                      trikeRegistrationNo: details?.trikeRegistrationNo || "",
                    },
                  },
                }),
              )
            }
          />
        )}

        <ReceivedBy />
      </div>
    </div>
  );
};

export default VehicleInformation;
